import { GET_DELIVERY_AGENT_ITEMS_SUMMARY } from "../constants/endpoints";
import axiosClient from "./axios";

class DeliveryAgentItemsSummaryService {
  static async getDeliveryAgentItemsSummary(
    shopId: string,
    startDate: string,
    endDate: string
  ) {
    const response = await axiosClient.post(GET_DELIVERY_AGENT_ITEMS_SUMMARY, {
      shopId,
      startDate,
      endDate,
    });
    return response;
  }
}

export default DeliveryAgentItemsSummaryService;
